module.exports = __webpack_public_path__ + "img/europe_icon.5bf4131d.png";